module.exports = __webpack_public_path__ + "bd58b4ed5899cc726d30b7f67094da3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card-bkg.jpg
// module id = lw5M
// module chunks = 2